// Define exclusive category groups that should never overlap
export const EXCLUSIVE_CATEGORIES = {
  // Communication & Collaboration
  'Communication': [
    'Communication',
    'Team Communication',
    'Chat',
    'Video Conferencing',
    'Messaging'
  ],

  // Project Management & Task Tracking
  'Project Management': [
    'Project Management',
    'Task Management',
    'Work Management',
    'Team Collaboration',
    'Project Tracking'
  ],

  // Development & Version Control
  'Development': [
    'Version Control',
    'DevOps',
    'Engineering',
    'Development Tools',
    'Code Management'
  ],

  // Marketing & Analytics
  'Marketing': [
    'Marketing',
    'Digital Marketing',
    'SEO',
    'Marketing Analytics',
    'Marketing Automation'
  ],

  // Design & Creative
  'Design': [
    'Design & Creative',
    'Video & Streaming',
    'Creative Tools'
  ],

  // Service Management
  'Service': [
    'Field Service',
    'Service Management',
    'Customer Support'
  ],

  // Payment Tools
  'Payments': [
    'Payment Processing',
    'Invoicing'
  ]
} as const;